/* eslint-disable */
// Bootstrap-Komponenten gezielt importieren
import Alert     from 'bootstrap/js/dist/alert';
import Button    from 'bootstrap/js/dist/button';
import Carousel  from 'bootstrap/js/dist/carousel';
import Collapse  from 'bootstrap/js/dist/collapse';
import Dropdown  from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Modal     from 'bootstrap/js/dist/modal';
import Popover   from 'bootstrap/js/dist/popover';
import ScrollSpy from 'bootstrap/js/dist/scrollspy';
import Tab       from 'bootstrap/js/dist/tab';
import Toast     from 'bootstrap/js/dist/toast';
import Tooltip   from 'bootstrap/js/dist/tooltip';
/* eslint-enable */

// Deine inits (falls nötig)
import './_tooltip-init';
import './_toast-init';

// ------------------------------
// A) Named Exports (für ESM-Imports)
// ------------------------------
export {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Offcanvas,
  Modal,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip,
};

// ------------------------------
// B) Globale API (für Nicht-ESM-Skripte)
// ------------------------------
window.bootstrap = window.bootstrap || {};
Object.assign(window.bootstrap, {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Offcanvas,
  Modal,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip,
});

// Optional: Shortcuts (falls du sie irgendwo nutzt)
window.BsAlert     = Alert;
window.BsButton    = Button;
window.BsCarousel  = Carousel;
window.BsCollapse  = Collapse;
window.BsDropdown  = Dropdown;
window.BsOffcanvas = Offcanvas;
window.BsModal     = Modal;
window.BsPopover   = Popover;
window.BsScrollSpy = ScrollSpy;
window.BsTab       = Tab;
window.BsToast     = Toast;
window.BsTooltip   = Tooltip;

// Polyfill-Helfer (falls ältere BS-Version ohne getOrCreateInstance)
window.bootstrapGetOrCreate = function (CtorOrName, el) {
  const Ctor = typeof CtorOrName === 'string' ? window.bootstrap[CtorOrName] : CtorOrName;
  if (!Ctor) return null;
  if (typeof Ctor.getOrCreateInstance === 'function') {
    return Ctor.getOrCreateInstance(el);
  }
  const existing = Ctor.getInstance?.(el);
  return existing || new Ctor(el);
};